Alerts = require 'app/scripts/views/lib/alerts'
Backbone = require 'app/scripts/lib/backbone'
Hearsay = require 'hearsay'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
f = require 'effing'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
l = require 'app/scripts/lib/localize'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'

class CollectionWithHelpers extends Backbone.Collection
  constructor: (models, options) ->
    @modelCache = options?.modelCache
    super

  destructor: ->
    @stopListening()
    Util.shred(@)


  create: (model, [options]..., next) ->
    if !options && !_.isFunction(next)
      options = next
      next = ->

    # We want to ignore any notifications of this model type while we're waiting
    # for this model to be created (so we don't create a duplicate model if the
    # model notification comes back before we get a response for the API call)
    modelType = @model
    options ?= {}

    lockIndex = @modelCache.lock("Collection Create")

    options.success = f.concat (options.success ? ->), (model) =>
      next(null, model)

    customError = options.error
    options.error = (model, xhr, options) =>
      textStatus = xhr?.responseText
      status = xhr?.status
      if customError?
        customError(status, textStatus)
      else
        showApiErrors = getExperiment('showApiErrors')
        if showApiErrors.get('enabled')
          track("CollectionWithHelpers", "Test Show Server Error", textStatus)
          msg = l('alerts.changes not saved')
          Alerts.showHtml templates.fill('connect_failed', { msg }),
            'error',
            'CollectionWithHelpersFail'
        else
          track("CollectionWithHelpers", "Hidden Server Error", textStatus)
      next(textStatus)

    options.complete = f.choke(0, @modelCache, 'unlock', lockIndex)

    options.modelCache ?= @modelCache

    super(model, options)

  _update: (newModels) ->
    shouldReset =
      if newModels.length == @models.length
        oldIds = {}
        @models.forEach (m) -> oldIds[m.cid] = true
        newModels.some (m) -> !oldIds[m.cid]
      else
        true

    if shouldReset
      @reset(newModels)

  owner: (@owner) ->
    @

  syncModel: (@sourceModel, attr, { fxGetIds } = {}) ->
    @modelCache = @sourceModel.modelCache
    ids = {}
    getIds = =>
      attrValue = @sourceModel.get(attr)
      fxGetIds?(attrValue) ? attrValue ? []

    # Wrap the update method so that we don't have to re-compute collectionIds
    # every time.
    update = (collectionIds) =>
      models = _.chain(collectionIds)
      .map (id) => @modelCache.get(@model, id)
      .compact()
      .value()

      @_update models

    @sync = =>
      newIds = getIds()
      ids = {}
      for id in newIds
        ids[id] = true
      update(newIds)

    @listenTo @sourceModel, "change:#{ attr }", @sync

    @listenTo @modelCache, "add:#{ @model::typeName }", (model) ->
      if ids[model.id]
        @add model
      return

    @listenTo @modelCache, "remove:#{ @model::typeName }", (model) ->
      if ids[model.id]
        @remove model
      return

    @sync()
    @

  syncCache: (@modelCache, watchedAttrs, pred) ->
    @sync = =>
      @_update @modelCache.all(@model).filter(pred)

    typeName = @model::typeName
    @listenTo @modelCache, "add:#{ typeName }", (model) =>
      if pred(model)
        @add(model)

    @listenTo @modelCache, "remove:#{ typeName }", (model) =>
      if pred(model)
        @remove(model)

    @listenTo @modelCache, "reset:#{ typeName }", @sync

    for attr in watchedAttrs
      @listenTo @modelCache, "change:#{ typeName }:#{ attr }", (model) ->
        if pred(model)
          @add(model)
        else
          @remove(model)

    @sync()
    @

  syncSubModels: (@sourceModel, attr, discardUnknown) ->
    @modelCache ?= @sourceModel.modelCache
    @sync = =>
      currentModels = @models
      subModelsJSON = @sourceModel.get(attr) ? []

      newModels = for json in subModelsJSON
        subModel = _.find(@models, (m) -> m.id == json.id)
        if subModel?
          @modelCache.enqueueDelta(subModel, json)
        else
          subModel = new @model(json, { @modelCache, collection: @ })
        subModel

      if !discardUnknown
        # We may know of some new models that haven't been saved yet
        for model in @models when !model.id?
          newModels.push(model)

      @_update(newModels)

    @listenTo(@sourceModel, "change:#{ attr }", @sync)

    @sync()
    @

  snoop: (attrs...) ->
    events = ['add', 'remove', 'reset']
    .concat attrs.map (attr) ->
      ["change", attr].join(":")
    .join(" ")

    new Hearsay.ContinuousSignal (send) =>
      send(@)
      update = =>
        send(@)
      @listenTo @, events, update
      =>
        @stopListening @, events, update

module.exports = CollectionWithHelpers
